export default "__VITE_ASSET__DNfwPmv4__"